import Axios from "axios";
import Vue from "vue";
import i18n from "../../i18n";
import { get } from "lodash";
import { API_HOST } from "../../config/app-const";
import { normalize } from "../../helpers/pagination";
import { filtersToQuery } from '../../helpers/filters';

import { PROJECTS } from '../../config/const';

import { Promise } from "core-js";
import { setAccessToken } from "../../mixins/insight/setAccessToken";
import { makePublicInsightApiRequest } from "../../helpers/request";

const state = {
  projects: {
    isBusy: false,
    data: null,
    error: null
  },
  active_projects: {
    isBusy: false,
    data: null,
    error: null
  },
  project: {
    isBusy: false,
    data: null,
    error: null
  },
  coderProjects: {
    isBusy: false,
    data: null,
    error: null
  },
  organization_projects: {
    isBusy: false,
    data: null,
    error: null
  },
  projectSettings: {
    isBusy: false,
    data: null,
    error: null
  }
};

const getters = {
  projectLastUpdate: (state) => {
    if (!get(state, 'project.data.master_last_updated_at'))
      return null;

    const iso = new Date(state.project.data.master_last_updated_at).toISOString();

    return `${iso.slice(0, 10)} ${iso.slice(11, 16)} UTC`;
  },

  projectCurrency: state => {
    if (
      !state.project ||
      !state.project.data ||
      !state.project.data.ave_currency
    ) {
      return PROJECTS.DEFAULT_CURRENCY;  
    }

    return state.project.data.ave_currency;
  },
};


const mutations = {
  LOAD_PROJECTS_BUSY: (state, payload) => {
    state.projects.isBusy = payload;
  },
  LOAD_PROJECTS_SUCCESS: (state, payload) => {
    state.projects.data = payload;
    state.projects.error = null;
  },
  LOAD_PROJECTS_FAIL: (state, payload) => {
    state.projects.data = null;
    state.projects.error = payload;
  },

  LOAD_ALL_PROJECTS_BUSY: (state, payload) => {
    state.active_projects.isBusy = payload;
  },
  LOAD_ALL_PROJECTS_SUCCESS: (state, payload) => {
    state.active_projects.data = payload;
    state.active_projects.error = null;
  },
  LOAD_ALL_PROJECTS_FAIL: (state, payload) => {
    state.active_projects.data = null;
    state.active_projects.error = payload;
  },

  CREATE_PROJECT_BUSY: (state, payload) => {
    state.active_projects.isBusy = payload;
  },
  CREATE_PROJECT_SUCCESS: (state) => {
    state.active_projects.error = null;
  },
  CREATE_PROJECT_FAIL: (state, payload) => {
    state.active_projects.data = null;
    state.active_projects.error = payload;
  },
  
  GET_PROJECT_BUSY: (state, payload) => {
    state.project.isBusy = payload;
  },
  GET_PROJECT_SUCCESS: (state, payload) => {
    state.project.data = payload;
    state.project.error = null;
  },
  GET_PROJECT_FAIL: (state, payload) => {
    state.project.data = null;
    state.project.error = payload;
  },

  ADD_SELECTED_PROJECT_TO_PROJECTS(state, payload) {
    state.projects.data.data.push(payload)
  },

  GET_CODER_PROJECTS_BUSY: (state, payload) => {
    state.coderProjects.isBusy = payload;
  },
  GET_CODER_PROJECTS_SUCCESS: (state, payload) => {
    state.coderProjects.data = payload;
    state.coderProjects.error = null;
  },
  GET_CODER_PROJECTS_FAIL: (state, payload) => {
    state.coderProjects.data = null;
    state.coderProjects.error = payload;
  },
  // ADD CODER TO PROJECT
  ADD_CODER_TO_PROJECT_BUSY: (state, payload) => {
    state.coderProjects.isBusy = payload;
  },
  ADD_CODER_TO_PROJECT_SUCCESS: (state, payload) => {
    state.coderProjects.data = payload;
    state.coderProjects.error = null;
  },
  ADD_CODER_TO_PROJECT_FAIL: (state, payload) => {
    state.coderProjects.data = null;
    state.coderProjects.error = payload;
  },
  // REMOVE PROJECTS FROM CODER
  REMOVE_PROJECT_FROM_CODER_BUSY: (state, payload) => {
    state.coderProjects.isBusy = payload;
  },
  REMOVE_PROJECT_FROM_CODER_SUCCESS: (state, payload) => {
    const projectIndex = state.coderProjects.data.findIndex(p => p.id == payload.id);
    let projects = [...state.coderProjects.data];
    projects.splice(projectIndex, 1);
    state.coderProjects.data = projects;
    state.coderProjects.error = null;
  },
  REMOVE_PROJECT_FROM_CODER_FAIL: (state, payload) => {
    state.coderProjects.data = null;
    state.coderProjects.error = payload;
  },
  LOAD_ORGANIZATION_PROJECTS_SUCCESS: (state, payload) => {
    state.organization_projects.data = payload;
    state.organization_projects.error = null;
  },
  LOAD_ORGANIZATION_PROJECTS_FAIL: (state, payload) => {
    state.organization_projects.data = null;
    state.organization_projects.error = payload;
  },
  LOAD_ORGANIZATION_PROJECTS_BUSY: (state, payload) => {
    state.organization_projects.isBusy = payload;
  },
  LOAD_PROJECT_SETTINGS_BUSY: (state, payload) => {
    state.projectSettings.isBusy = payload.status;
    state.projectSettings.pid = payload.pid;
  },
  LOAD_PROJECT_SETTINGS_SUCCESS: (state, payload) => {
    state.projectSettings.data = payload.data;
    state.projectSettings.pid = payload.pid;
    state.projectSettings.error = null;
  },
  LOAD_PROJECT_SETTINGS_FAIL: (state, payload) => {
    state.projectSettings.data = null;
    state.projectSettings.error = payload;
  }
};

const actions = {
  getProjects: ({ commit, state, rootState }, { pagination, filters }) => {
    return new Promise((resolve, reject) => {
    if (state.projects.isBusy == false) {
      commit("LOAD_PROJECTS_BUSY", true);

      const { accessToken } = rootState.user.user.data;

      const config = {
        headers: { Authorization: `Token token=${accessToken}` }
      };
      
      let query = "?";
      const normalizedPagination = normalize(pagination);
      Object.keys(normalizedPagination).map((param, i) => {
        query += `${param}=${normalizedPagination[param]}${i !== Object.keys(normalizedPagination).length - 1 ? '&' : ''}`;
      });

      const normalizedFilters = normalize(filters || {});
      if (Object.keys(normalizedFilters).length > 0) {
        query += "&";
        Object.keys(normalizedFilters).map((param, i) => {
          query += `project_filters[${param}]=${normalizedFilters[param]}${i !== Object.keys(normalizedFilters).length - 1 ? '&' : ''}`;
        });
      }
      
      return Axios.get(`${API_HOST}/analysis/projects${query}`, config)
        .then(response => {
          const res = response.data;
          let payload = {};

          if (pagination.page == 1) {
            payload = res.data;
          }
          else {
            const projectsList = state.projects.data.data;
            payload = Object.assign({}, res.data, { data: [...projectsList, ...res.data.data] });
          }
          
          commit("LOAD_PROJECTS_SUCCESS", payload);
          resolve()
        })
        .catch(error => {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });

          console.error(error);
          commit("LOAD_PROJECTS_FAIL", error);
          reject()
        })
        .finally(() => commit("LOAD_PROJECTS_BUSY", false));
    }
  })
  },

  
  createProject: ({ commit, rootState }, { project }) => {
    commit("CREATE_PROJECT_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };
    
    const body = {
      ...project
    }
    return new Promise((resolve, reject) => {
      Axios.post(
        `${API_HOST}/analysis/projects/create`, body , config
      )
      .then(
        response => {
          commit("CREATE_PROJECT_SUCCESS");
          resolve(response.data),
        error => {
          commit("CREATE_PROJECT_FAIL", error);
          reject(error);
        }
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("CREATE_PROJECT_FAIL", error);
      })
      .finally(() => commit("CREATE_PROJECT_BUSY", false));
    })
  },

  getAllProjects: ({ commit, state, rootState }, { pagination, filters }) => {
    if (state.projects.isBusy == false) {
      commit("LOAD_ALL_PROJECTS_BUSY", true);

      const { accessToken } = rootState.user.user.data;

      const config = {
        headers: { Authorization: `Token token=${accessToken}` }
      };
      
      let query = "?";
      const normalizedPagination = normalize(pagination);
      Object.keys(normalizedPagination).map((param, i) => {
        query += `${param}=${normalizedPagination[param]}${i !== Object.keys(normalizedPagination).length - 1 ? '&' : ''}`;
      });
      
      if (filters) {
        const filtersQuery = filtersToQuery(filters);
        
        if (filtersQuery != '') {
          query += '&' + filtersQuery;
        }
      }

      Axios.get(`${API_HOST}/analysis/projects/all${query}`, config)
        .then(response => {
          const res = response.data;
          let payload = {};
          
          if (pagination.page == 1) {
            payload = res.data;
          }
          else {
            const projectsList = state.projects.data.data;
            payload = Object.assign({}, res.data, { data: [...projectsList, ...res.data.data] });
          }
          
          commit("LOAD_ALL_PROJECTS_SUCCESS", payload);
        })
        .catch(error => {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });

          console.error(error);
          commit("LOAD_ALL_PROJECTS_FAIL", error);
        })
        .finally(() => commit("LOAD_ALL_PROJECTS_BUSY", false));
    }
  },

  getCurrency: ({ dispatch, state}, { projectId } ) => {
    if (
      !state.project ||
      !state.project.data ||
      !state.project.data.ave_currency
      ) {
      dispatch('getProject', { projectUid: projectId });
    }
  },

  getProject: ({ commit, state, rootState }, { projectUid }) => {
    if (state.project.isBusy == false) {
      commit("GET_PROJECT_BUSY", true);

      const config = {
        headers: { Authorization: setAccessToken(rootState) }
      };

      const params = `?project_id=${projectUid}`

      return Axios.get(`${API_HOST}/analysis/projects/${projectUid}${params}`, config)
        .then(response => {
          commit("GET_PROJECT_SUCCESS", response.data);
        })
        .catch(error => {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });

          console.error(error);
          commit("GET_PROJECT_FAIL", error);
        })
        .finally(() => commit("GET_PROJECT_BUSY", false));
    }
  },
  getCoderProjects: ({ commit, rootState }, { coderId }) => {
    commit("GET_CODER_PROJECTS_BUSY", true);

    const { accessToken } = rootState.user.user.data;

    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };
    return Axios.get(`${API_HOST}/analysis/coders/${coderId}/projects`, config)
      .then(response => {
        commit("GET_CODER_PROJECTS_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("GET_CODER_PROJECTS_FAIL", error);
      })
      .finally(() => commit("GET_CODER_PROJECTS_BUSY", false));
  },
  addCoderToProject: ({ commit, rootState }, { projectId, coderId, obj }) => {
    commit("ADD_CODER_TO_PROJECT_BUSY", true);

    const { accessToken } = rootState.user.user.data;

    const body = {
      ...obj
    };

    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios.put(`${API_HOST}/analysis/${projectId}/coder/${coderId}/assign`, body, config)
      .then(response => {
        commit("ADD_CODER_TO_PROJECT_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("ADD_CODER_TO_PROJECT_FAIL", error);
      })
      .finally(() => commit("ADD_CODER_TO_PROJECT_BUSY", false));
  },

  removeProjectFromCoder: ({ commit, rootState }, { projectId, row, removeProject }) => {
    commit("REMOVE_PROJECT_FROM_CODER_BUSY", true);

    const { accessToken } = rootState.user.user.data;

    const body = {
      ...removeProject
    };
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios.delete(`${API_HOST}/analysis/${projectId}/coder/${row.id}/unassign`, config)
      .then(response => {
        commit("REMOVE_PROJECT_FROM_CODER_SUCCESS", body);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("REMOVE_PROJECT_FROM_CODER_FAIL", error);
      })
      .finally(() => commit("REMOVE_PROJECT_FROM_CODER_BUSY", false));
  },

  getOrganizationProjects: ({ commit }, { organizationId, enableMobileAppAdvanced }) => {
    commit("LOAD_ORGANIZATION_PROJECTS_BUSY", true);
    let url = `/v4/organizations/${organizationId}/projects-list`;
    if (enableMobileAppAdvanced) {
      url += `?enable_mobile_app_advanced=${enableMobileAppAdvanced}`;
    }
    makePublicInsightApiRequest({url: url, method: "GET"})
      .then(response => {
        commit("LOAD_ORGANIZATION_PROJECTS_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });
        commit("LOAD_ORGANIZATION_PROJECTS_FAIL", error);
      })
      .finally(() => commit("LOAD_ORGANIZATION_PROJECTS_BUSY", false));
  },

  getProjectSettings: ({ commit, state, rootState }, { projectId }) => {
    const pid = parseInt(projectId, 10);

    // Already loaded for this project
    if (state.projectSettings.data?.id === pid && !state.projectSettings.error) {
      return Promise.resolve(state.projectSettings.data);
    }

    commit("LOAD_PROJECT_SETTINGS_BUSY", { status: true, pid: pid });

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    const isCurrentRequest = () => state.projectSettings.pid === pid;

    const promise = Axios.get(`${API_HOST}/projects/${projectId}/settings`, config)
      .then(response => {
        if (!isCurrentRequest()) {
          return;
        }
        const settings = response.data.data || response.data;
        commit("LOAD_PROJECT_SETTINGS_SUCCESS", { data: settings, pid: pid });
        return settings;
      })
      .catch(error => {
        if (isCurrentRequest()) {
          commit("LOAD_PROJECT_SETTINGS_FAIL", error);
        }
        throw error;
      })
      .finally(() => {
        if (isCurrentRequest()) {
          commit("LOAD_PROJECT_SETTINGS_BUSY", { status: false, pid });
        }
      });

    return promise;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
